import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import ClassesPage from "@/pages/ClassesPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import BookingResult from "@/pages/BookingResult";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/clases" element={<ClassesPage />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/booking/success" element={<BookingResult status="success" />} />
        <Route path="/booking/failure" element={<BookingResult status="failure" />} />
        <Route path="/booking/pending" element={<BookingResult status="pending" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
